import { useState, useEffect } from 'react';


import Lookupservice from "../../services/eventsLookupService";
import EventsList from './eventsratification/EventsListAdmin';
import { recordError } from "../../utils/logService";


 const EventListView = ()=> {

    const [defaultStatus, setDefaultStatus] = useState();
    const [statuses, setStatuses] = useState([]);

    useEffect(() => {
        getEventStatus();
      }, []);

    const getEventStatus = async () => {
        try {
          const response = await Lookupservice.getEventStatus();
          var statusData = [];
          if (response && response.status == 200) {
            const { data } = response;
            data.sort((a, b) => a.key - b.key);
            statusData = data
            .filter((status) => status.value !== "In Revision")
            .map((status) => ({
              key: status.key,
              label: status.value,
            }));

            const defaultStatus = data.find((c) => c.value === "Submitted");
            
            setDefaultStatus(defaultStatus)
            setStatuses(statusData);


            // // setSelectedStatus(data[0].key);
            // getEventsByStatus({statusKey: data[0].key});
            //  // Initialize daysToEvent visibility based on the first status
            // const initialStatusLabel = data[0].value;
            // setShowDaysToEventColumn(["Submitted", "In Progress"].includes(initialStatusLabel));
          }
          else {
            // setSelectedStatus([]);
          }
        } catch (error) {
          recordError(error);
        }
      };
    
    return ( <div>
      {defaultStatus ? <EventsList statuses={statuses} defaultStatus={defaultStatus}/>: ""}
      </div>);
}

export default EventListView;